<template>
  <label :for="id + '_button'" :class="{'active': isActive}" class="toggle__button">
    <input class="button-switch" type="checkbox" :id="id + '_button'" v-model="checkedValue"
           :disabled="$props.disabled">
    <span class="toggle__switch"></span>
  </label>
</template>

<script>
export default {
  name: 'switch-button',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: 'primary'
    },
    defaultState: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentState: this.defaultState
    }
  },
  watch: {
    defaultState: {
      handler () {
        this.currentState = Boolean(this.defaultState)
      },
      immediate: true
    }
  },
  computed: {
    isActive () {
      return this.currentState
    },
    checkedValue: {
      get () {
        return this.currentState
      },
      set (newValue) {
        this.currentState = newValue
        this.$emit('change', newValue)
      }
    }
  }
}
</script>

<style lang="scss">
.toggle__button {
  vertical-align: middle;
  user-select: none;
  cursor: pointer;

  input[type="checkbox"] {
    opacity: 0;
    position: absolute;
    width: 46px;
    height: 30px;
    cursor: pointer;
    bottom: 30px;

    &:disabled {
      cursor: not-allowed;
    }
  }

  .toggle__switch {
    display: inline-block;
    height: 16px;
    border-radius: 10px;
    width: 48px;
    background: $font-inactive;
    position: relative;
    cursor: pointer;
    transition: opacity 0.3s;
    will-change: opacity;

    &::after{
      content: "";
      position: absolute;
      display: block;
      height: 24px;
      width: 24px;
      border-radius: 50%;
      left: 0;
      top: -4px;
      transform: translateX(0);
      transition: transform 0.3s;
      will-change: transform;
      box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.3);
    }
    &::after {
      background: #ffffff url("/assets/images/tiny_gray_close.svg") no-repeat center;
    }
  }
}

.active .toggle__switch {
  background-color: $primary;

  &::after {
    transform: translateX(25px);
    background: #ffffff url("/assets/images/tiny_gray_close.svg") no-repeat center;
  }
}

</style>
